import { Button, styled as muiStyled } from '@mui/material';

export const DownloadButton = muiStyled(Button)(() => ({
  padding: '6px 12px',
  display: 'flex',
  borderRadius: '4px',
  maxHeight: '32px',
}));
